<template>
  <div
    ref="partialDiv"
    :class="{
      'container mt-6 px-0': true,
    }"
  >
    <component
      :is="getComponent(title._type)"
      v-if="title?._type"
      :value="title"
    />
    <p
      :class="{
        'mb-4 text-center text-xs leading-7 text-www-color-neutral-medium-dark md:text-15px': true,
      }"
    >
      {{ subtitle }}
    </p>
    <div
      :class="{
        'grid grid-cols-12 gap-6': true,
      }"
    >
      <template
        v-for="(card, index) in ussIntentCards"
        :key="index"
      >
        <UssIntentCard
          v-bind="card"
          :is-selected="selectedIntent === card.intentValue"
          @select="onSelectIntent"
        />
      </template>
    </div>
    <div
      :class="{
        'm-auto': true,
      }"
    >
      <slot />
    </div>
    <template v-if="screenPartialData?.sectionBuilder?.length > 0">
      <component
        :is="getComponent(component._type)"
        v-for="component in screenPartialData?.sectionBuilder"
        :key="component._key"
        :value="component"
      />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import type { SignupPartialViewsSectionBuilder, UssIntent } from '~/sanity/types';
import UssIntentCard from './UssIntentCard.vue';
import { getComponent } from '~/components/Mapper';
import type UnifiedSignupSessionInfo from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/session-info/UnifiedSignupSessionInfo';
import type IntentSignupScreen from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/screens/IntentSignupScreen';

interface Props extends UssIntent {
  signupScreen: IntentSignupScreen;
  sessionInfo: UnifiedSignupSessionInfo;
  screenPartialData: SignupPartialViewsSectionBuilder;
}
const props = defineProps<Props>();
const { signupScreen } = props;
const intentField = signupScreen.getField(FieldHtmlNameUtil.whatIsYourIntent);
const selectedIntent = ref<string>(intentField.val as string);
const partialDiv = ref<HTMLElement | null>(null);

const onSelectIntent = (value: string) => {
  selectedIntent.value = value;
  intentField.val = value;
};

const onCodeEmbedRendered = () => {
  const firstName = signupScreen.getField(FieldHtmlNameUtil.firstName).val;
  const firstNameElement = partialDiv.value?.querySelector('[hekate-data="firstName"]');
  if (firstNameElement) {
    firstNameElement.textContent = `${firstName}`;
  }
};

onMounted(() => {
  partialDiv.value?.addEventListener('code-embed-rendered', onCodeEmbedRendered);
});

onUnmounted(() => {
  partialDiv.value?.removeEventListener('code-embed-rendered', onCodeEmbedRendered);
});
</script>

<style></style>
